import RoosterLogo from '../resources/RoosterLogo.svg'
export default function Rooster() {
    return (
        <img
			alt='brand'
			className='grid place-items-center object-contain w-14 h-14'
			src={RoosterLogo}
		/>
    )
}